package net.sergeych.tools

@Suppress("unused")
class AtomicCounter(initialValue: Long = 0) : AtomicValue<Long>(initialValue) {
    fun incrementAndGet(): Long = mutate { it+1 }
}